module.exports = {
      id: "play-icon-usage",
      viewBox: "0 0 156 156",
      url: "/typo3conf/ext/samson_druck_sitepackage/Resources/Public/Theme/img/" + "sprite.svg#play-icon",
      toString: function () {
        return this.url;
      }
    }